// Vite entrypoint for the dashboard page
import '../js/shared/fonts.ts'
import { enforcePreferredLocale } from '../js/shared/auth-locale-redirect.ts'
enforcePreferredLocale()
import { initAppsignal } from '../js/shared/appsignal.ts'
initAppsignal()
import '../css/style.css'
import '../css/dashboard-blueprint.css'
import '../js/components'
import { initDashboard } from '../js/dashboard/dashboard.ts'
import { initFeedback } from '../js/pages/feedback.ts'
import { initProfilePage } from '../js/pages/profile.ts'
import { initI18n } from '../js/shared/i18n.ts'
import { initSearch } from '../js/shared/search.ts'

document.addEventListener('DOMContentLoaded', async () => {
  await initI18n()
  initDashboard()
  initSearch()
  initFeedback()
  initProfilePage()
})
